export enum PackageStatusProgressType {

    NotPassed,
    InProgress,
    Completed,
}
